export const RESERVED_BREAKOUT_NAMES = ['new'];

export function breakoutNameKey(name) {
  if (name == null) {
    return null;
  }
  const trimmed = String(name).trim();
  return trimmed === '' ? null : trimmed.toLowerCase();
}

export function isReservedBreakoutName(name) {
  const key = breakoutNameKey(name);
  return key != null && RESERVED_BREAKOUT_NAMES.includes(key);
}

export function findBreakoutIndexByName(breakouts = [], name) {
  const key = breakoutNameKey(name);
  if (key == null) {
    return null;
  }
  const index = breakouts.findIndex((b) => breakoutNameKey(b?.name) === key);
  return index === -1 ? null : index;
}

export function isBreakoutNameUnique(
  breakouts = [],
  name,
  { excludeIndex = null } = {}
) {
  const key = breakoutNameKey(name);
  if (key == null) {
    return false;
  }
  return !breakouts.some(
    (b, i) => i !== excludeIndex && breakoutNameKey(b?.name) === key
  );
}

export function breakoutPathSegment(name) {
  return encodeURIComponent(String(name).trim());
}
